export const environment = {
    production: true,
    hmr       : false,
    name      : 'prd'
};
